/**
 * @file 記録の日付 (YYYY-MM-DD) の生成と表示。
 *
 * @what: 今日の日付を端末のローカル日付で作る (記録の `date` はサーバに送る文字列で、時刻を持たない)。
 *   表示は「2026/8/22」の形に直す。
 * @why: 取り組みの記録と教材のメモ履歴が同じ日付の扱いをする (別々に持つと表記が揺れる)。
 * @failure: 形式が YYYY-MM-DD でない文字列は、そのまま返す。
 */

export function todayLocal(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** 「2026-08-22」→「2026/8/22」。年を省くときは withYear=false (「8/22」)。 */
export function formatLogDate(date: string, withYear = true): string {
  const [y, m, d] = date.split("-");
  if (!y || !m || !d) return date;
  return withYear ? `${y}/${Number(m)}/${Number(d)}` : `${Number(m)}/${Number(d)}`;
}

/** YYYY-MM-DD の日付文字列に日数を足す (負も可)。比較は文字列の辞書順で足りる形を保つ。 */
export function addDaysLocal(date: string, days: number): string {
  const [y, m, d] = date.split("-").map(Number);
  const t = new Date(y ?? 1970, (m ?? 1) - 1, (d ?? 1) + days);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(t.getDate())}`;
}
